import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import usePrevious from './usePrevious';
import { getURLParameter } from '#helper';

const useUrlPagination = ({ page, pages, changePage }) => {
  const dispatch = useDispatch();
  const searchPage = getURLParameter('page');
  const pageNumber = Number(searchPage) || 1;

  const prevParamPage = usePrevious(pageNumber);
  const prevPage = usePrevious(page);

  useEffect(() => {
    if (pageNumber < 1 || (pages && pageNumber > pages)) {
      dispatch(changePage(1, { refetch: false }));
    } else if (page !== pageNumber) {
      if (prevParamPage && pageNumber !== prevParamPage) {
        dispatch(changePage(pageNumber));
      } else if (page !== prevPage) {
        dispatch(changePage(pageNumber, { refetch: false }));
      }
    }
  }, [dispatch, page, prevPage, pageNumber, prevParamPage, pages, changePage]);
};

export default useUrlPagination;
